import { ErrorBoundary, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React, { useMemo } from 'react';

import { CustomerDetailFullAccount } from '../../../../../../store/customerDetail/types';
import { DataListContainer } from '../DataListContainer';
import { InfoContainer } from '../InfoContainer';
import { CustomerDuckInfoProps } from '../InfoContainer/components/CustomerDuckInfo';

import {
  getAbleToOperateInfo,
  getAccountAndIncomeInfos,
  getBlockingReasonsInfo,
  getSuitabilityInfo,
} from './constants';

interface ContainerFinancialDataProps {
  customerDetailFull: CustomerDetailFullAccount | null | undefined;
  hasError?: boolean;
  onRefresh?: () => void;
  isLoading?: boolean;
}

export const ContainerFinancialData: React.FC<ContainerFinancialDataProps> = ({
  customerDetailFull,
  hasError,
  isLoading,
  onRefresh,
}) => {
  const accountAndIncomeInfosColumns = useBreakpointValue({ base: 1, sm: 3, md: 6 });
  const blockingReasonsInfosColumns = useBreakpointValue({ base: 1, sm: 2, md: 4 });
  const suitabilityInfosColumns = useBreakpointValue({ base: 1, sm: 3, md: 5 });
  const ableToOperateInfosColumns = useBreakpointValue({ base: 1, sm: 3 });

  const accountAndIncomeInfos = useMemo(
    () => getAccountAndIncomeInfos(customerDetailFull, isLoading || false),
    [customerDetailFull, isLoading]
  );

  const blockingReasonsInfos: CustomerDuckInfoProps[] = useMemo(
    () => getBlockingReasonsInfo(customerDetailFull, isLoading || false),
    [customerDetailFull, isLoading]
  );

  const suitabilityInfos: CustomerDuckInfoProps[] = useMemo(
    () => getSuitabilityInfo(customerDetailFull, isLoading || false),
    [customerDetailFull, isLoading]
  );

  const ableToOperateInfos: CustomerDuckInfoProps[] = useMemo(
    () => getAbleToOperateInfo(customerDetailFull, isLoading || false),
    [customerDetailFull, isLoading]
  );

  if (hasError) {
    return (
      <DataListContainer>
        <ErrorBoundary onRefresh={onRefresh} />
      </DataListContainer>
    );
  }

  return (
    <DataListContainer>
      <VStack space="stack.xxxs">
        <InfoContainer
          title="Conta e Rendimento"
          values={accountAndIncomeInfos}
          columns={accountAndIncomeInfosColumns}
        />
        <InfoContainer
          title="Bloqueios do cliente"
          values={blockingReasonsInfos}
          columns={blockingReasonsInfosColumns}
          forceEqualColumns
        />
        <InfoContainer
          title="Perfil do Investidor"
          values={suitabilityInfos}
          columns={suitabilityInfosColumns}
        />
        <InfoContainer
          title="Habilitado a operar em:"
          values={ableToOperateInfos}
          columns={ableToOperateInfosColumns}
        />
      </VStack>
    </DataListContainer>
  );
};
